import { COUNTRY, FLAG, PREP_END_DATE_MARKER, PREP_START_DATE_MARKER, ZIPCODE } from '@/constants/string';
import { defaultVariablesColor, END_DATE_MARKER, START_DATE_MARKER, TIME_COUNTDOWN_MARKER } from '@/constants/string';
import { ActionList, ActionListItemDescriptor, Button, Popover } from '@shopify/polaris';
import { CodeAddIcon } from '@shopify/polaris-icons';
import { useMemo, useState } from 'react';

interface IProps {
  handleAddText: (text: string) => void;
  isAddSimpleText?: boolean;
  className?: string;
  listDisabledTemplate?: {
    countDown?: boolean;
    country?: boolean;
    flag?: boolean;
    startDate?: boolean;
    endDate?: boolean;
    prepStartDate?: boolean;
    prepEndDate?: boolean;
    zipcode?: boolean;
  };
  isHideBtnText?: boolean;
}

const ButtonAddVariable = ({ handleAddText, isAddSimpleText, listDisabledTemplate, className, isHideBtnText }: IProps) => {
  const [showModalVariable, setShowModalVariable] = useState(false);

  const commonActions = useMemo(() => {
    return [
      !listDisabledTemplate?.countDown && {
        content: `${TIME_COUNTDOWN_MARKER}`,
        onAction: () => {
          handleAddText(
            isAddSimpleText
              ? ` ${TIME_COUNTDOWN_MARKER}`
              : ` <strong style="color: ${defaultVariablesColor};">${TIME_COUNTDOWN_MARKER}</strong>`,
          );
        },
      },
      !listDisabledTemplate?.startDate && {
        content: `${START_DATE_MARKER}`,
        onAction: () => {
          handleAddText(
            isAddSimpleText
              ? ` ${START_DATE_MARKER}`
              : ` <strong style="color: ${defaultVariablesColor};">${START_DATE_MARKER}</strong>`,
          );
        },
      },
      !listDisabledTemplate?.endDate && {
        content: `${END_DATE_MARKER}`,
        onAction: () => {
          handleAddText(
            isAddSimpleText
              ? ` ${END_DATE_MARKER}`
              : ` <strong style="color: ${defaultVariablesColor};">${END_DATE_MARKER}</strong>`,
          );
        },
      },
      !listDisabledTemplate?.prepStartDate && {
        content: `${PREP_START_DATE_MARKER}`,
        onAction: () => {
          handleAddText(
            isAddSimpleText
              ? ` ${PREP_START_DATE_MARKER}`
              : ` <strong style="color: ${defaultVariablesColor};">${PREP_START_DATE_MARKER}</strong>`,
          );
        },
      },
      !listDisabledTemplate?.prepEndDate && {
        content: `${PREP_END_DATE_MARKER}`,
        onAction: () => {
          handleAddText(
            isAddSimpleText
              ? ` ${PREP_END_DATE_MARKER}`
              : ` <strong style="color: ${defaultVariablesColor};">${PREP_END_DATE_MARKER}</strong>`,
          );
        },
      },
      !listDisabledTemplate?.country && {
        content: `${COUNTRY}`,
        onAction: () => {
          handleAddText(
            isAddSimpleText ? ` ${COUNTRY}` : ` <strong style="color: ${defaultVariablesColor};">${COUNTRY}</strong>`,
          );
        },
      },
      !listDisabledTemplate?.flag && {
        content: `${FLAG}`,
        onAction: () => {
          handleAddText(isAddSimpleText ? ` ${FLAG}` : ` <strong style="color: ${defaultVariablesColor};">${FLAG}</strong>`);
        },
      },
      !listDisabledTemplate?.zipcode && {
        content: `${ZIPCODE}`,
        onAction: () => {
          handleAddText(
            isAddSimpleText ? ` ${ZIPCODE}` : ` <strong style="color: ${defaultVariablesColor};">${ZIPCODE}</strong>`,
          );
        },
      },
    ].filter(Boolean) as ActionListItemDescriptor[];
  }, [handleAddText, isAddSimpleText, listDisabledTemplate]);

  return (
    <div className={className}>
      <Popover
        active={showModalVariable}
        activator={
          <Button onClick={() => setShowModalVariable((prev) => !prev)} icon={CodeAddIcon}>
            {isHideBtnText ? undefined : 'Variables'}
          </Button>
        }
        onClose={() => setShowModalVariable((prev) => !prev)}
      >
        <ActionList actionRole="menuitem" items={commonActions} />
      </Popover>
    </div>
  );
};

export default ButtonAddVariable;
